module.exports = __webpack_public_path__ + "static/img/limit-reward-banner.40f0136.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/limit-reward-banner.png
// module id = dsnT
// module chunks = 213